import React from 'react';
import PropTypes from 'prop-types';

const Section = ({
	children,
	heading,
	icon,
	iconOffset,
	order,
	orderType,
	background,
	withBorder,
	paddings,
	narrowGap,
	marginTop,
	mobileBorders,
}) => {
	const dynamicStyles = {
		order: order ? order : 'defaultOrderValue',
		backgroundColor: background ? background : null,
		border: withBorder == false && 'none',
		padding: paddings == false && 0,
		marginBottom: order == 1 && orderType == 'top' ? '16px' : '0px',
		marginTop: marginTop && `${marginTop}px`,
	};
	return (
		<>
			<div
				className={mobileBorders ? 'fields--group fields--group--mobileBox' : 'fields--group'}
				style={dynamicStyles}
			>
				<h2 className="heading-2">
					<span
						className="heading-2__img"
						style={{
							backgroundImage: `url(${icon})`,
							position: 'relative',
							top: `${iconOffset}px`,
						}}
					></span>
					<span className="fields--group__heading">{heading}</span>
				</h2>
				<div className="fields--group__wrapper" style={{ marginTop: narrowGap && '12px' }}>
					{children}
				</div>
			</div>
		</>
	);
};

Section.propTypes = {
	children: PropTypes.node,
	heading: PropTypes.string.isRequired,
	icon: PropTypes.string.isRequired,
	widthBorder: PropTypes.bool,
};

export default Section;
